<script setup>
import { useDeprecated } from '@daysmart/daysmart-vue-components/composables'
import getPaging from '@/core/utils/getPaging'

const props = defineProps({
  apiRequest: {
    type: Function,
    required: true,
  },
  pageSize: {
    type: Number,
    default: 25,
  },
})

const bus = useBus()

const currentPage = ref(1)
const response = ref()
const loading = ref(true)

async function fetch() {
  loading.value = true
  response.value = await props.apiRequest({
    pageSize: props.pageSize,
    currentPage: currentPage.value,
  })
  loading.value = false
}

async function changePage(page) {
  currentPage.value = page
  await fetch()
}

const hasEntries = computed(() => {
  return response.value?.results ? response.value.results.length > 0 : false
})

const paging = computed(() => {
  return getPaging({
    responseData: response.value,
    defaultPageSize: props.pageSize,
  })
})

const pagingConfig = computed(() => ({
  paging: {
    currentPage: currentPage.value,
    totalPages: paging.value?.totalPages,
    count: paging.value?.count,
    perPage: paging.value?.perPage,
    bus,
  },
}))

const showDataSummary = computed(() => {
  return response.value.count >= props.pageSize
})

onMounted(async () => {
  await fetch()
})

bus.on('update:page', changePage)
provide('dataQuery', pagingConfig)
provide('dataBus', computed(() => bus))

useDeprecated({ suggestedComponent: 'DSDataPaginatedTemplate' })
</script>

<template>
  <DSLoadingWrapper :loading="loading">
    <template v-if="hasEntries">
      <div class="flex sm:(flex-row justify-between) xs:(flex-col items-center flex-gap-y-3.5)">
        <DataPagerSummary v-if="showDataSummary" />
        <DataPager />
      </div>
      <slot
        name="data"
        v-bind="{ entries: response?.results || [], refresh: fetch }"
      />
      <div class="flex sm:(flex-row justify-between) xs:(flex-col items-center flex-gap-y-3.5)">
        <DataPagerSummary v-if="showDataSummary" />
        <DataPager />
      </div>
    </template>
    <template v-else>
      <slot name="noDataAlert" />
    </template>
  </DSLoadingWrapper>
</template>
